import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Locations from './components/Locations';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import { AuthProvider } from './context/AuthContext';
import AdminLogin from './pages/AdminLogin';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <div className="App">
                <Header />
                <main>
                  <Hero />
                  <About />
                  <Products />
                  <Services />
                  <Gallery />
                  <Locations />
                  <Contact />
                </main>
                <Footer />
                <FloatingWhatsApp />
              </div>
            }
          />
          <Route path="/admin" element={<AdminLogin />} />
        
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
